const HeroContent = (props) => {
  return (
    <div
      className="flex items-center justify-center relative z-50"
      style={{ height: "70vh", width: "50vw" }}
    >
      <div className="flex flex-col items-center justify-center">
        <h1 className="text-5xl font-bold text-white">Güven Karabulut</h1>
        <h2 className="text-2xl font-bold text-white">
          a Junior Backend Developer
        </h2>
      </div>
    </div>
  );
};

export default HeroContent;
